import { render } from "./CustomSelectOneHorseSex.vue?vue&type=template&id=5d134364"
import script from "./CustomSelectOneHorseSex.vue?vue&type=script&lang=js"
export * from "./CustomSelectOneHorseSex.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__